import { computed, isRef } from "vue";
import { useI18n } from "vue-i18n";

export { default as State } from "./State.vue";

export function useState(type = "search") {
    const _type = computed(() => (isRef(type) ? type.value : type));

    const { t } = useI18n();

    const state = computed(() => {
        switch (_type.value) {
            case "asset":
                return {
                    type: "Assets",
                    title: t("components.state.no_assets.title"),
                    text: t("components.state.no_assets.text"),
                };
            case "asset_files":
                return {
                    type: "Files",
                    title: t("components.state.no_asset_files.title"),
                    text: t("components.state.no_asset_files.text"),
                };
            case "asset_group":
                return {
                    type: "Assets",
                    title: t("components.state.no_asset_groups.title"),
                    text: t("components.state.no_asset_groups.text"),
                };
            case "files":
                return {
                    type: "Files",
                    title: t("components.state.no_files.title"),
                    text: t("components.state.no_files.text"),
                };
            case "files_search":
                return {
                    type: "Files",
                    title: t("components.empty_states.no_results.title"),
                    text: (query) =>
                        t("components.empty_states.no_results.search", {
                            query,
                        }),
                };
            case "space":
                return {
                    type: "Spaces",
                    title: t("components.state.no_spaces.title"),
                    text: t("components.state.no_spaces.text"),
                };
            default:
                return {
                    type: "NoResults",
                    title: t("components.state.no_results.title"),
                    text: t("components.state.no_results.text"),
                };
        }
    });

    return {
        state,
    };
}
